import styled from "styled-components";

export const ContentInfoFiscal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  flex-wrap: wrap;
  color: #303947;

  @media screen and (max-width: 1629px) {
    width: 100%;
    flex-direction: column;
  }
`

export const CardInfoFiscal = styled.div`
  width: 100%;
  max-height: 48vh;
  overflow: auto;
  border-radius: 10px;
  padding: 14px;

  @media screen and (max-width: 1000px) {
    height: auto;
  }

  ::-webkit-scrollbar-track {
      background-color: transparent;
  }
  ::-webkit-scrollbar {
      width: 6px;
      background: #F4F4F4;
      border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb {
      background: #f97316;
      border-radius: 5px;
  }
`
